// extracted by mini-css-extract-plugin
export default {"item":"index_item_YgWno","icon":"index_icon_N0rCD","setIcon":"index_setIcon_IkU1W","setIconActive":"index_setIconActive_cSv08","link":"index_link_konkA"};